import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=657ad50e&"
import script from "./Campaigns.vue?vue&type=script&lang=ts&"
export * from "./Campaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports